import api from "./api";

export const authService = {
  // Login user and store token & user details
  login: async (username, password) => {
    const response = await api.post("/auth/login", { username, password });
    if (response.data && response.data.token) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Get current logged-in user profile from API
  getProfile: async () => {
    const response = await api.get("/auth/me");
    if (response.data && response.data.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout user and clear localStorage
  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  // Retrieve user object from localStorage
  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem("user");
      return userStr ? JSON.parse(userStr) : null;
    } catch (e) {
      return null;
    }
  },

  // Retrieve token from localStorage
  getToken: () => {
    return localStorage.getItem("token");
  },

  // Save updated user to localStorage
  setCurrentUser: (user) => {
    localStorage.setItem("user", JSON.stringify(user));
  }
};

export default authService;
